import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminGPSLocationGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var gpsLocationGrid = this;
		setTimeout(function(){
			gpsLocationGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var gpsLocationGrid = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
			if (!gpsLocationGrid.selectedCompanyId) {
				unitField.items = [];
				return Promise.resolve();
			}

			return UnitService.getUnitLookupService().getUnitsForCompany(gpsLocationGrid.selectedCompanyId, refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnitsForCompany(gpsLocationGrid.selectedCompanyId, refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (gpsLocationGrid.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							gpsLocationGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							loadReferenceLookup('TRACTOR');
							ElementUtil.query(toolbarFilter, 'filterTractorId').value = '';	
							
							grid.items = [];
						}
					}					
				},				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,					
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',
					label: 'Status',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}									
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'recordDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.recordDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'location',
					header: 'Location',
					width: '10em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.location.addressLine1 + ' ' + rowData.item.location.city + ', ' + rowData.item.location.stateProv + ' ' + rowData.item.location.country; 
					}
				},
				{						
					path: 'location.heading',
					header: 'Heading',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'location.latitude',
					header: 'Latitude',
					width: '7em'
				},
				{						
					path: 'location.longitude',
					header: 'Longitude',
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.odometer && rowData.item.odometer.odometer) {
							root.innerHTML = rowData.item.odometer.odometer;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'totalDistance.distance',
					header: 'Distance (MI)',
					width: '7em'
				},
				{						
					path: 'totalDistance.tollDistance',
					header: 'Toll Distance (MI)',
					width: '7em'
				},
				{						
					path: 'calculationMethodDescription',
					header: 'Calculation Method',
					width: '7em'
				},
				{						
					path: 'odometer.reset',
					header: 'Odometer Reset',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						if (rowData.item.odometer) {
							root.innerHTML = rowData.item.odometer.resetRecord;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'location.comment',
					header: 'Comment',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'totalDistance.ferryDistance',
					header: 'Ferry Distance (MI)',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'driverRefNo',
					header: 'Driver Ref No',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'taxable',
					header: 'Taxable',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'vehicleStatus.speed',
					header: 'Speed',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.speed) {
							root.innerHTML = rowData.item.vehicleStatus.speed + ' ' + rowData.item.vehicleStatus.speedUOM;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'vehicleStatus.ignitionOn',
					header: 'Ignition/Engine On ',
					hidden: true,
					width: '7em', 
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.vehicleStatus.ignitionOn + ' / ' + rowData.item.vehicleStatus.engineOn;
					}
				},
				{						
					path: 'inMotion',
					header: 'In Motion',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'vehicleStatus.currentFuelTankLevelPercent',
					header: 'Tank Level Percent',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'vehicleStatus.currentFuelTankLevel',
					header: 'Tank Level Amount',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.currentFuelTankLevel) {
							root.innerHTML = rowData.item.vehicleStatus.currentFuelTankLevel + ' ' + rowData.item.vehicleStatus.tankLevelUom;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'vehicleStatus.engineTime',
					header: 'Total Engine Time',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.engineTime) {
							root.innerHTML = rowData.item.vehicleStatus.engineTime + ' ' + rowData.item.vehicleStatus.engineTimeUom;
						} else {
							root.innerHTML = '';
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				var distance = record.totalDistance.distance ? record.totalDistance.distance : 0;
				var toll = record.totalDistance.tollDistance ? record.totalDistance.tollDistance : 0;
				var ferry = record.totalDistance.ferryDistance ? record.totalDistance.ferryDistance : 0;
				
				if (record.distanceUom === 'KM') {
					totalDistance += UOMUtil.convertKMToMI(distance);
					totalToll += UOMUtil.convertKMToMI(toll);
					totalFerry += UOMUtil.convertKMToMI(ferry);
				} else {
					totalDistance += distance;
					totalToll += toll;
					totalFerry += ferry;
				}
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};				
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus =  ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus =  ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
					if (companyId) {
						var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
						if (tractorId) {
							DataManagementService.getAdminDataService().exportGPSLocations(tractorId, grid.currentFilter);
						} else {
							ElementUtil.query(toolbarFilter, 'filterTractorId').validate();
							window.DL.MessageUtil.showToastError('A tractor must be selected');
						}
					} else {
						ElementUtil.query(toolbarFilter, 'filterCompany').validate();
						window.DL.MessageUtil.showToastError('A Company must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							status: ElementUtil.query(toolbarFilter, 'status').value,	
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'recordDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totalDistance = Math.round(records.totalDistance.distance * 10)/10;
							var totalTollDistance = Math.round(records.totalDistance.tollDistance * 10)/10;
							var totalFerryDistance = Math.round(records.totalDistance.ferryDistance * 10)/10;
																		
							distanceStatus.innerHTML = '<b>Distance:</b> ' + totalDistance + 
							' Toll: ' + totalTollDistance + 
							' Ferry: ' + totalFerryDistance + 
							' MI | ';							
											
						};
						var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
						if (companyId) {
							var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
							if (tractorId) {						
								DataManagementService.getAdminDataService().getGPSLocations(companyId, tractorId, grid.currentFilter).then(function(records){
									successHandler(records);
								});						
							} else {
								loadMask.remove();
								if (gpsLocationGrid.nextLoadOfGrid) {
									ElementUtil.query(toolbarFilter, 'filterTractorId').validate();								
									window.DL.MessageUtil.showToastError('A tractor must be selected');
								} else {
									gpsLocationGrid.nextLoadOfGrid = true;
								}
							}
						} else {
							loadMask.remove();
							ElementUtil.query(toolbarFilter, 'filterCompany').validate();								
							window.DL.MessageUtil.showToastError('A Company must be selected');
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		gpsLocationGrid.append(flexLayout);	
		
		loadReferenceLookup('TRACTOR', '');
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(gpsLocationGrid, toolbarFilter,
			['filterCompany','filterTractorId','status','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterCompany !== undefined && data.filterCompany !== null) {
						ElementUtil.query(toolbarFilter, 'filterCompany').value = data.filterCompany;
						gpsLocationGrid.selectedCompanyId = data.filterCompany;
					}
					if (data.status !== undefined && data.status !== null) {
						ElementUtil.query(toolbarFilter, 'status').value = data.status;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								if (!gpsLocationGrid.selectedCompanyId) {
									return Promise.resolve({data: []});
								}
								return UnitService.getUnitLookupService().getUnitsForCompany(
									gpsLocationGrid.selectedCompanyId, referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
				
	}
	
}
customElements.define('dl-admin-gpslocations-grid', AdminGPSLocationGrid);
